import { TFlatStatsEntries } from './flatStats';

export enum EFlatStatsStatus {
  Initial = 'initial',
  Loading = 'loading',
  Succeed = 'succeed',
  Failed = 'failed',
}

interface IFlatStatsState {
  status: EFlatStatsStatus;
  result: TFlatStatsEntries | null;
  errorMessage: string;
}

export interface IFlatStatsStateNotFetched extends IFlatStatsState {
  status: EFlatStatsStatus.Initial | EFlatStatsStatus.Loading | EFlatStatsStatus.Failed;
  result: null;
}

export interface IFlatStatsStateFetched extends IFlatStatsState {
  status: EFlatStatsStatus.Succeed;
  result: TFlatStatsEntries;
  errorMessage: '';
}

export type TFlatStatsState = IFlatStatsStateFetched | IFlatStatsStateNotFetched;
